import { createContext, type RefObject, useContext } from "react";

export type CalendarView = "month" | "day";

type DashboardCalendarContextValue = {
	/** yyyy-MM */
	month: string;
	pickedDate: Date | null;
	view: CalendarView;
	/** Ref for the section "Zeiterfassung", the target of `scrollToCalendar`. */
	calendarRef: RefObject<HTMLElement>;
	goToMonth(month: string): void;
	/** A day step across the edge of the month changes the month too. */
	goToDate(date: Date): void;
	selectDate(date: Date): void;
	setView(view: CalendarView): void;
	scrollToCalendar(): void;
};

export const DashboardCalendarContext = createContext<DashboardCalendarContextValue | null>(null);

export function useDashboardCalendar() {
	const value = useContext(DashboardCalendarContext);
	if (!value) throw new Error("useDashboardCalendar needs a DashboardCalendarProvider.");
	return value;
}
